import { Alert, Button, Divider, Grid, IconButton } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { GetAllAlmacenesList } from "../../../../hooks/getListAlmacen";
import { TipoSplitEnum } from "../../../../@enums/tipo_split";
import { AreaAlmacenEnum, TiposAlmacenEnum } from "../../../../@enums/tipo_almacen";
import ItemReport from "./itemReport";
import { ReportarMovimiento, RevertirReporte } from "../../../../hooks/reportMovimiento";
import swal from "sweetalert2";
import { GetRutaParte } from "../../../../hooks/getRutasParte";
import { useSelector } from "react-redux";
import { useLoading } from "../../../../components/Loading/useLoading";
import { GetAyudasVisuales } from "../../../../hooks/getAyudasVisuales";
import { TicketLocal } from "../../../../hooks/sendPrint";
import { GetAllDefectivos } from "../../../../hooks/defectivos";
import { ModalDefectivo } from "./modales/modalDefectivo";
import { ItemReportCuarentena } from "./itemReportCuarentena";
import { AyudasVisualesPanel } from "./ayudasVisuales";
import CarouselImg from "../../../../components/carousel";
import { ModalConfirmacionTag } from "./modales/modalConfirmacionTag";
import { useSnackbar } from "notistack";

const Reportar = ({ movimiento, setMovReporting, setSaveReport, saveReport, setIsReporting, seccionId, getMovimientos, get_Cargados, get_procesados, alm }) => {
  const { setAppLoading } = useLoading();
  const printerId = useSelector((state) => state.app.printerId);
  const formData = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const { getAllDefectivosMutation } = GetAllDefectivos();
  const { getAllAlmacenesListMutation } = GetAllAlmacenesList();
  const { reportarMovimientoMutation } = ReportarMovimiento();
  const { getAyudasVisualesMutation } = GetAyudasVisuales();
  const { revertirReporteoMutation } = RevertirReporte();
  const { ticketLocalMutation } = TicketLocal();
  const { getRutaParteMutation } = GetRutaParte();
  const [almacenes, setAlmacenes] = useState([]);
  const [indexSelect, setIndexSelect] = useState(null);
  const [error, setError] = useState(false);
  const [cuestionario, setCuestionario] = useState(null);
  const [ayudasVisuales, setAyudasVisuales] = useState([]);
  const [rutas, setRutas] = useState([]);
  const [autoMaster, setAutoMaster] = useState(true);
  const [defectivos, setDefectivos] = useState([]);
  const [openDefectivo, setOpenDefectivo] = useState(false);
  const [isCuarentena, setIsCuarentena] = useState(false);
  const [isExterno, setIsExterno] = useState(false);
  const [openConfirmTag, setOpenConfirmTag] = useState(false);
  const [tagsPrint, setTagsPrint] = useState(null);
  const [bodyReverse, setBodyReverse] = useState(null);
  const [parteFueraDeRuta, setParteFueraDeRuta] = useState(false);
  const { apiResources } = useSelector((state) => ({
    apiResources: state.app.apiResources,
  }));
  const [arraySplit, setArraySplit] = useState([{ moin_id: movimiento?.datos[0]?.moin_id, cantidad: movimiento?.existencia_total, split: [], ok: true, almacen: movimiento?.almacen, tipoSplit: TipoSplitEnum.REGULAR, idCert: cuestionario, respuestas: [], part_id: movimiento?.part_id, serial: movimiento?.datos[0]?.serial, tag_id: movimiento?.datos[0]?.tag_id, almacen_actual: seccionId, master: false, isCuarentena: false, defectivo: null, isExterno: false }])
  console.log(movimiento)
  const get_almacenes = () => {
    setAppLoading(true)
    getAllAlmacenesListMutation(
      {},
      {
        onSuccess: (data) => {
          let itms = data.filter(item => item.tipo === TiposAlmacenEnum.ALMACEN);
          let alm = itms.find(item => item.id === seccionId);
          console.log(alm);
          if (alm?.area === AreaAlmacenEnum.CUARENTENA || alm?.area === AreaAlmacenEnum.EXTERNO) {
            alm?.area === AreaAlmacenEnum.CUARENTENA ? setIsCuarentena(true) : setIsExterno(true);
            let split = [...arraySplit];
            alm?.area === AreaAlmacenEnum.CUARENTENA ? split[0].isCuarentena = true : split[0].isExterno = true;
            split[0].idCert = null;
            split[0].ok = false;
            split[0].ok = false;
            split[0].almacen = null;
          }
          setAlmacenes(itms);
          setAppLoading(false)
        },
        onError: (error) => {
          setAppLoading(false)
          console.log(error);
        },
      }
    );
  };

  const get_cuestionario = () => {
    getRutaParteMutation(movimiento?.part_id, {
      onSuccess: (data) => {
        let array = arraySplit;
        let rutaIndex = data.findIndex(ruta => ruta?.alma_id === seccionId);
        let ruta_act = data.find(ruta => ruta?.alma_id === seccionId);
        setRutas(data)
        if (ruta_act !== undefined) {
          let cues = null
          if (rutaIndex === 0) {
            // si se encuentra al inicio de la ruta se toma el certificado de traspaso
            cues = ruta_act?.cues_reporteoid;
            array[0].idCert = cues;
          } else {
            // si no se encuentra al inicio de la ruta se toma el certificado de E/S
            if (ruta_act?.rupr_revisionentradasalida) {
              cues = ruta_act?.cues_id;
              array[0].idCert = cues;
            }
          }
          array.map(item => item.master = ruta_act?.rupr_generamasterreporteo);
          setAutoMaster(ruta_act?.rupr_generamasterreporteo)
          setArraySplit([...array]);
          setCuestionario(cues);
        } else {
          array[0].idCert = null;
          setArraySplit([...array]);
          setCuestionario(null);
        }

        if (!ruta_act) {
          setParteFueraDeRuta(true)
        } else {
          setParteFueraDeRuta(false)
        }
      },
      onError: (error) => {
        console.log(error)
      }
    })
  }
  const getResources = (id) => {
    setAppLoading(true);
    getAyudasVisualesMutation(id, {
      onSuccess: (data) => {
        setAyudasVisuales(data);
        setAppLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setAppLoading(false);
      },
    });
  };
  const get_defectivos = () => {
    setAppLoading(true);
    getAllDefectivosMutation({}, {
      onSuccess: (data) => {
        setDefectivos(data);
        setAppLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setAppLoading(false);
      },
    })
  }

  useEffect(() => {
    get_almacenes();
    get_cuestionario();
    let mov = movimiento;
    movimiento.existencia_total = 0;
    setMovReporting({ ...mov })
    getResources(mov?.part_id)
  }, []);

  useEffect(() => {
    if (arraySplit.length === 1) {
      get_defectivos();
    }
  }, [arraySplit.length]);

  useEffect(() => {
    if (saveReport) {
      saveData()
    }
  }, [saveReport]);

  const validate = () => {
    let emptyCant = arraySplit.some(item => item.cantidad === null);
    let emptyAlm = arraySplit.some(item => item.almacen === null);
    let emptySplit = arraySplit.some(item => item.split.length === 0);
    let emptyResponse = arraySplit.some(item => item.idCert !== null && item.respuestas.length === 0);
    let emptyDef = arraySplit.some(item => !isCuarentena && item.isCuarentena && item.defectivo === null);
    if (emptyAlm || emptyCant || emptySplit || emptyResponse || emptyDef) {
      setError(true)
      return false
    } else {
      setError(false);
      return true
    }
  }

  const saveData = () => {
    if (validate()) {
      setAppLoading(true);
      let data = arraySplit;
      data.forEach(item => {
        item.respuestas.forEach(res => {
          res.cure_respuesta = Array.isArray(res?.cure_respuesta)
            ? JSON.stringify(res?.cure_respuesta)
            : res?.cure_respuesta;
        })
      })
      reportarMovimientoMutation(
        { printerId, almacenOrigen: alm, movimientos: data },
        {
          onSuccess: async (data) => { // <-- Hacemos onSuccess async
            swal.fire({
              position: "top-end",
              icon: "success",
              title: "Movimiento reportado con éxito",
              showConfirmButton: false,
              timer: 1000,
            });

            try {
              setTagsPrint(data?.data?.prints)
              setBodyReverse(data?.data?.revers_data)
              for (let print of data?.data?.prints) {
                await new Promise((resolve, reject) => {
                  ticketLocalMutation(print, {
                    onSuccess: (response) => {
                      console.log(response);
                      resolve(); // Solo avanza cuando se complete esta petición
                    },
                    onError: (error) => {
                      console.log(error);
                      reject(error); // Detiene la secuencia si hay error
                    },
                  });
                });
              }
              setAppLoading(false);
              setOpenConfirmTag(true)
            } catch (error) {
              console.error("Error en el proceso de impresión:", error);
            }
          },
          onError: (error) => {
            setSaveReport(false);
            swal.fire({
              position: "top-end",
              icon: "error",
              title: error?.mensaje,
              showConfirmButton: false,
              timer: 1000,
            });
            setAppLoading(false);
          },
        }
      );

    } else {
      setSaveReport(false)
    }

  }

  const onCloseReport = () => {
    setSaveReport(false);
    setIsReporting(false);
    setOpenConfirmTag(false);
    setTagsPrint(null);
    setBodyReverse(null);
    setMovReporting(null);
    get_Cargados(seccionId);
    get_procesados(seccionId);
    getMovimientos(seccionId);

  }

  const addData = () => {
    let new_data = { moin_id: movimiento?.datos[0]?.moin_id, cantidad: null, split: [], ok: false, almacen: 5, tipoSplit: TipoSplitEnum.REGULAR, idCert: null, respuestas: [], part_id: movimiento?.part_id, serial: movimiento?.datos[0]?.serial, tag_id: movimiento?.datos[0]?.tag_id, almacen_actual: seccionId, master: false, isCuarentena: true, defectivo: null }
    setArraySplit([...arraySplit, new_data])
  }

  const revertData = (data) => {
    setAppLoading(true);
    revertirReporteoMutation(bodyReverse, {
      onSuccess: (data) => {
        enqueueSnackbar('Movimientos revertidos', {
          autoHideDuration: 2000,
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onError: (error) => {
        enqueueSnackbar('No se pudo revertir los movimientos', {
          autoHideDuration: 2000,
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onSettled: () => {
        setAppLoading(false);
        onCloseReport();
      }
    })
  }

  return (
    <>
      <Grid item xs={12} sx={{ p: 1 }} className="center_item">
        <form ref={formData} id="form_dom" style={{ width: "100%" }}>
          {
            parteFueraDeRuta && <Alert severity="warning" style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>Parte fuera de ruta</Alert>
          }
          <Grid container spacing={0} sx={{ width: '100%' }}>
            <Grid item xs={12} sm={12} md={4} lg={2} xl={2} sx={{ p: 1, alignItems: 'flex-end' }} className="center_item">
              <Button
                variant="contained"
                sx={{ mr: 1, p: 1, width: '100% !important', minWidth: '20px', height: 35 }}
                onClick={addData}
                disabled={movimiento?.existencia_total === 0}
              >
                Cuarentena
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={5} xl={ayudasVisuales.length > 1 ? 5 : 6} sx={{ p: 1, alignItems: 'flex-end' }} className="center_item">
              {error && <p style={{ color: 'red' }}>Existen datos por completar, favor de verificar</p>}
            </Grid>
          </Grid>
          <Grid container spacing={0} sx={{ width: '100%' }}>
            <Grid item xs={12} sm={12} md={8} lg={10} xl={10} sx={{ p: 1, flexDirection: 'column', justifyContent: 'flex-start' }} className="center_item">
              {
                arraySplit?.map((item, index) => (
                  <>
                    {isCuarentena || isExterno ? (
                      <ItemReportCuarentena
                        key={`enc_${index}`}
                        almacenes={
                          item?.isCuarentena ?
                            almacenes?.filter(item => (item.area === AreaAlmacenEnum.EXTERNO || item.area === AreaAlmacenEnum.SCRAP) && item.id !== seccionId) :
                            almacenes?.filter(item => item.area === AreaAlmacenEnum.CUARENTENA && item.id !== seccionId)
                        }
                        arraySplit={arraySplit}
                        formData={formData}
                        index={index}
                        item={item}
                        movimiento={movimiento}
                        setArraySplit={setArraySplit}
                        setIndexSelect={setIndexSelect}
                        setMovReporting={setMovReporting}
                        defectivos={defectivos}
                        setOpenDefectivo={setOpenDefectivo}
                        ruta={rutas[0]}
                      />
                    ) : (
                      <ItemReport
                        key={`enc_${index}`}
                        almacenes={almacenes}
                        arraySplit={arraySplit}
                        formData={formData}
                        index={index}
                        item={item}
                        movimiento={movimiento}
                        setArraySplit={setArraySplit}
                        setIndexSelect={setIndexSelect}
                        setMovReporting={setMovReporting}
                        exist_question={item.idCert !== null}
                        cuestionario={cuestionario}
                        autoMaster={autoMaster}
                        defectivos={defectivos}
                        setOpenDefectivo={setOpenDefectivo}
                      />
                    )}
                  </>
                ))
              }
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={2} xl={2} sx={{ p: 1, alignItems: 'flex-start', flexDirection: 'column' }} className="center_item">
              <span style={{ marginBottom: 5, fontSize: 20, fontWeight: 600 }}>Recursos</span>
              <CarouselImg
                key={'carousel'}
                recursos={ayudasVisuales}
              />

              <Divider sx={{ mt: 2, mb: 2, width: '100%' }} />
              <AyudasVisualesPanel
                key={'ayudas_visuales_gen'}
                id_part={movimiento?.part_id}
                setAyudas={() => { }}
                setOpenAyudas={() => { }}
                canClose={false}
              />
            </Grid>
          </Grid>

        </form>
      </Grid>
      <ModalDefectivo key='modal_def' open={openDefectivo} setOpen={setOpenDefectivo} update_list={get_defectivos} />
      <ModalConfirmacionTag key='modal_conf' open={openConfirmTag} setOpen={setOpenConfirmTag} dataReprint={tagsPrint} onClose={onCloseReport} revertData={revertData} />
    </>
  )
}

export default Reportar;